<template>
  <div class="vx-row">
    <div class="vx-col w-1/12"></div>
    <div class="vx-col w-10/12 form">
      <!-- Villa selection and inspection by -->
      <div class="vx-col w-full m-5">
        <div class="vx-row">
          <div class="vx-col w-1/12"></div>
          <v-select
            class="vx-col w-4/12"
            label="text"
            placeholder="Select Property"
            :options="propertiesOptions"
            @input="propertySelected"
            v-model="property"
            :clearable="false"
          ></v-select>
          <div class="vx-col w-2/12"></div>
          <vs-input
            placeholder="Inspection by"
            class="vx-col w-4/12"
            v-model="inspection_by"
          ></vs-input>
          <div class="vx-col w-1/12"></div>
        </div>
      </div>
      <!-- Pool -->
      <div class="vx-col w-full m-5">
        <h1 class="m-5">Pool</h1>
        <div
          v-for="(question, index) in pool_questions"
          :key="index"
          class="vx-row m-5"
        >
          <div
            class="vx-col w-1/2">
            {{question.title}}
          </div>
          <div
            class="vx-col w-1/4">
            <vs-radio
              class="vx-col w-1/2"
              :vs-name="question.uuid"
              v-model="question.value"
              :vs-value="true">
              Yes
            </vs-radio>
            <vs-radio
              class="vx-col w-1/2"
              :vs-name="question.uuid"
              v-model="question.value"
              :vs-value="false">
              No
            </vs-radio>
          </div>
          <div
            class="vx-col w-1/4"
            >
            <vs-input
              class="w-full"
              v-model="question.comment"
              placeholder="comment"
            ></vs-input>
          </div>
        </div>
      </div>

      <!-- Courtyard -->
      <div class="vx-col w-full m-5">
        <h1 class="m-5">Courtyard</h1>
        <div
          v-for="(question, index) in courtyard_questions"
          :key="index"
          class="vx-row m-5"
        >
          <div
            class="vx-col w-1/2">
            {{question.title}}
          </div>
          <div
            class="vx-col w-1/4">
            <vs-radio
              class="vx-col w-1/2"
              :vs-name="question.uuid"
              v-model="question.value"
              :vs-value="true">
              Yes
            </vs-radio>
            <vs-radio
              class="vx-col w-1/2"
              :vs-name="question.uuid"
              v-model="question.value"
              :vs-value="false">
              No
            </vs-radio>
          </div>
          <div
            class="vx-col w-1/4"
            >
            <vs-input
              class="w-full"
              v-model="question.comment"
              placeholder="comment"
            ></vs-input>
          </div>
        </div>
      </div>

      <!-- Gazebo -->
      <div class="vx-col w-full m-5">
        <h1 class="m-5">Gazebo</h1>
        <div
          v-for="(question, index) in gazebo_questions"
          :key="index"
          class="vx-row m-5"
        >
          <div
            class="vx-col w-1/2">
            {{question.title}}
          </div>
          <div
            class="vx-col w-1/4">
            <vs-radio
              class="vx-col w-1/2"
              :vs-name="question.uuid"
              v-model="question.value"
              :vs-value="true">
              Yes
            </vs-radio>
            <vs-radio
              class="vx-col w-1/2"
              :vs-name="question.uuid"
              v-model="question.value"
              :vs-value="false">
              No
            </vs-radio>
          </div>
          <div
            class="vx-col w-1/4"
            >
            <vs-input
              class="w-full"
              v-model="question.comment"
              placeholder="comment"
            ></vs-input>
          </div>
        </div>
      </div>

      <!-- General -->
      <div class="vx-col w-full m-5">
        <h1 class="m-5">General</h1>
        <div
          v-for="(question, index) in general_questions"
          :key="index"
          class="vx-row m-5"
        >
          <div
            class="vx-col w-1/2">
            {{question.title}}
          </div>
          <div
            class="vx-col w-1/4">
            <vs-radio
              class="vx-col w-1/2"
              :vs-name="question.uuid"
              v-model="question.value"
              :vs-value="true">
              Yes
            </vs-radio>
            <vs-radio
              class="vx-col w-1/2"
              :vs-name="question.uuid"
              v-model="question.value"
              :vs-value="false">
              No
            </vs-radio>
          </div>
          <div
            class="vx-col w-1/4"
            >
            <vs-input
              class="w-full"
              v-model="question.comment"
              placeholder="comment"
            ></vs-input>
          </div>
        </div>
      </div>

      <!-- Living Room\Dining Room -->
      <div class="vx-col w-full m-5">
        <h1 class="m-5">Living and Dining Room</h1>
        <div class="vx-row">
          <div class="vx-col w-1/2 mt-5 ml-5"><h4>Questions</h4></div>
          <div class="vx-col w-1/8 mt-5"><h4>Living Room</h4></div>
          <div class="vx-col w-1/8 mt-5"><h4>Dining Room</h4></div>
        </div>
        <div
          v-for="(question, index) in living_room_and_dining_room_questions"
          :key="index"
          class="vx-row m-5"
        >
          <div
            class="vx-col w-1/2">
            {{question.title}}
          </div>
          <div
            class="vx-col w-1/4">
            <vs-radio
              class="vx-col w-1/4"
              :vs-name="question.uuid"
              v-model="question.living_room_value"
              :vs-value="true">
              Yes
            </vs-radio>
            <vs-radio
              class="vx-col w-1/4"
              :vs-name="question.uuid"
              v-model="question.living_room_value"
              :vs-value="false">
              No
            </vs-radio>
            <vs-radio
              class="vx-col w-1/4"
              :vs-name="question.uuid2"
              v-model="question.dining_room_value"
              :vs-value="true">
              Yes
            </vs-radio>
            <vs-radio
              class="vx-col w-1/4"
              :vs-name="question.uuid2"
              v-model="question.dining_room_value"
              :vs-value="false">
              No
            </vs-radio>
          </div>
          <div
            class="vx-col w-1/4"
            >
            <vs-input
              class="w-full"
              v-model="question.comment"
              placeholder="comment"
            ></vs-input>
          </div>
        </div>
      </div>

      <!-- Kitchen -->
      <div class="vx-col w-full m-5">
        <h1 class="m-5">Kitchen Questions</h1>
        <div
          v-for="(question, index) in kitchen_questions"
          :key="index"
          class="vx-row m-5"
        >
          <div
            class="vx-col w-1/2">
            {{question.title}}
          </div>
          <div
            class="vx-col w-1/4">
            <vs-radio
              class="vx-col w-1/2"
              :vs-name="question.uuid"
              v-model="question.value"
              :vs-value="true">
              Yes
            </vs-radio>
            <vs-radio
              class="vx-col w-1/2"
              :vs-name="question.uuid"
              v-model="question.value"
              :vs-value="false">
              No
            </vs-radio>
          </div>
          <div
            class="vx-col w-1/4"
            >
            <vs-input
              class="w-full"
              v-model="question.comment"
              placeholder="comment"
            ></vs-input>
          </div>
        </div>
      </div>

      <!-- Bedrooms -->

      <div class="vx-col w-full m-5">
        <h1 class="m-5">Bedrooms</h1>
        <div class="vx-row m-5">
          <div class="vx-col w-1/2"></div>
          <div class="vx-col w-1/12">Bedroom 1</div>
          <div class="vx-col w-1/12">Bedroom 2</div>
          <div class="vx-col w-1/12">Bedroom 3</div>
          <div class="vx-col w-1/12">Bedroom 4</div>
          <div class="vx-col w-1/12">Bedroom 5</div>
        </div>
        <div
          v-for="(question, index) in bedroom_questions"
          :key="index"
          class="vx-row m-5"
        >
          <div
            class="vx-col w-1/2">
            {{question.title}}
          </div>
          <vs-checkbox 
            v-for="(value, index) in range"
            :key="index"
            class="vx-col w-1/12"
            :vs-name="question.uuid"
            v-model="question.bedroom_values[index].value">
            Yes
          </vs-checkbox >
        </div>
      </div>

      <!-- Bathroom / powder inventory -->

      <div class="vx-col w-full m-5">
        <h1 class="m-5">Bathrooms</h1>
        <div class="vx-row m-5">
          <div class="vx-col w-1/2"></div>
          <div class="vx-col w-1/12">Bathroom 1</div>
          <div class="vx-col w-1/12">Bathroom 2</div>
          <div class="vx-col w-1/12">Bathroom 3</div>
          <div class="vx-col w-1/12">Bathroom 4</div>
          <div class="vx-col w-1/12">Bathroom 5</div>
        </div>
        <div
          v-for="(question, index) in bathroom_questions"
          :key="index"
          class="vx-row m-5"
        >
          <div
            class="vx-col w-1/2">
            {{question.title}}
          </div>
          <vs-checkbox 
            v-for="(value, index) in range"
            :key="index"
            class="vx-col w-1/12"
            :vs-name="question.uuid"
            v-model="question.bathroom_values[index].value">
            Yes
          </vs-checkbox >
        </div>
      </div>
      <!-- Terrace / Message Room -->
      <div class="vx-col w-full m-5">
        <h1 class="m-5">Terrace and Massage room</h1>
        <div
          v-for="(question, index) in terrace_and_massage_room_questions"
          :key="index"
          class="vx-row m-5"
        >
          <div
            class="vx-col w-1/2">
            {{question.title}}
          </div>
          <div
            class="vx-col w-1/4">
            <vs-radio
              class="vx-col w-1/2"
              :vs-name="question.uuid"
              v-model="question.value"
              :vs-value="true">
              Yes
            </vs-radio>
            <vs-radio
              class="vx-col w-1/2"
              :vs-name="question.uuid"
              v-model="question.value"
              :vs-value="false">
              No
            </vs-radio>
          </div>
          <div
            class="vx-col w-1/4"
            >
            <vs-input
              class="w-full"
              v-model="question.comment"
              placeholder="comment"
            ></vs-input>
          </div>
        </div>
      </div>

      <!-- Inspection Comment -->
      <div class="vx-col w-full m-5">
        <h1 class="m-5">Inspection Comment</h1>
        <vs-textarea v-model="inspection_comment"></vs-textarea>
      </div>

      <!-- Upload documents -->
      <div class="vx-col w-full m-5">
          <h1 class="m-5"></h1>
          <div class="bannerBox mb-6">
            <!-- Displaying uploaded images -->
          <div class="item"  :key="index" v-for="(image, index) in images">
            <div class="img-upload">
              <img :src="image" />
              <!-- Is possible a small cross icon for this -->

              <button class="closebtn" @click="closeCalled(index)"><feather-icon icon="XIcon"></feather-icon></button>
            </div>
          </div>
          <div class="item">
            <div for="upload image" class="uploadBtn">
              <div class="innerContent">
              <span class="text">Upload File</span>
              <feather-icon icon="UploadIcon"></feather-icon>
              </div>
              <input
                type="file"
                id="upload image" @change="imageUploaded"  />
            </div>
          </div>
          <vs-popup title="Confirm" :active.sync="deleteImagePopup">
            <p class="mb-6"> Are you sure you want to delete the image? </p>
            <vs-button @click="removeImage" class="mr-6"> Yes </vs-button>
            <vs-button @click="deleteImagePopup=false"> No </vs-button>
          </vs-popup>
        </div>
      </div>

      <div class="vx-col w-full mt-4">
        <vue-recaptcha
        ref="recaptcha"
        :sitekey="captchaSiteKey"
        @verify="onRecaptchaVerified"
        @expired = "onRecaptchaExpired"
        ></vue-recaptcha>
        </div>

      <div class="mt-5 center">
        <vs-button @click="submitForm">Submit</vs-button>
      </div>
    </div> 
    <div class="vx-col w-1/12"></div>
  </div>
</template>

<script>
import PreArrivalChecklistFormSubmission from '../../../api/forms/preArrivalChecklistFormSubmission'
import {v4} from 'uuid'
import { showErrors, serverError, notification_time } from '@/utils/errorsUtils'
import { documentApi } from '../../../api'
import PropertyApi from '../../../api/property_management/propertyApi.js'
import vSelect from 'vue-select'
import { VueRecaptcha } from 'vue-recaptcha';

export default {
  components: {
    vSelect,
    VueRecaptcha,
  },
  data () {

    return {
      captchaSiteKey: process.env.VUE_APP_CAPTCHA_SITE_KEY,
      // images
      allowedTypes : ['jpg', 'jpeg', 'png'],
      uploadImagesStarted: false,
      uploadedImages: [],
      files: [],
      images: [],
      remove_index: -1,
      deleteImagePopup: false,
      // form 
      captchaToken: null,
      pool_questions: [
        { 
          uuid: v4(),
          title: 'Is the Pool pump working?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are the Pool lights working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Lion Spout working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Check if Pool cleaned ? ', 
          value: false,
          comment: ''
        }
      ],
      courtyard_questions: [
        { 
          uuid: v4(),
          title: 'Are all lights working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are all plug points working ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the garden cleaned ? ', 
          value: false,
          comment: ''
        }
      ],
      gazebo_questions: [
        { 
          uuid: v4(),
          title: 'Are all lights working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are all plug points working ? ', 
          value: false,
          comment: ''
        }
      ],
      general_questions : [
        { 
          uuid: v4(),
          title: 'Water pump working ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Generator working ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Genset Diesel check?', 
          value: false,
          comment: ''
        }
      ],
      living_room_and_dining_room_questions : [
        { 
          uuid: v4(),
          uuid2: v4(),
          title: 'AC Working ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { uuid: v4(),
          uuid2: v4(),
          title: 'Fans Functional?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { uuid: v4(),
          uuid2: v4(),
          title: 'Is Entry door lock functional?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { uuid: v4(),
          uuid2: v4(),
          title: 'Is the TV working ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { uuid: v4(),
          uuid2: v4(),
          title: 'Is the TV programmed correctly ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { uuid: v4(),
          uuid2: v4(),
          title: 'Is the TV remote working ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { uuid: v4(),
          uuid2: v4(),
          title: 'Are all electrical outlets & plug points functional ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { uuid: v4(),
          uuid2: v4(),
          title: 'All light buulbs functional ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { uuid: v4(),
          uuid2: v4(),
          title: 'Are the walls damage free ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { uuid: v4(),
          uuid2: v4(),
          title: 'WiFi functional throughout room ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { uuid: v4(),
          uuid2: v4(),
          title: 'Are the diffusers clean and full ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { uuid: v4(),
          uuid2: v4(),
          title: 'Is the Mosquito Repellent / Goodnight functioning and available ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        }
      ],
      kitchen_questions: [
        { 
          uuid: v4(),
          title: 'Is the entry door functional ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are all electrical outlets & plug points functional ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are all light bulbs working ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are walls damage free ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the second cylinder full ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the stove working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the Aquaguard working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the Fridge working ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the Microwave working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the tap cold working? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the Coffee machine working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the washing machine working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the dryer working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is Wifi functional ? ', 
          value: false,
          comment: ''
        }
      ],
      terrace_and_massage_room_questions: [
        { 
          uuid: v4(),
          title: 'Are the terrace lights working ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the refrigerator in bar counter working ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are the lights in the massage room working ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are the fans in the massage room working ?', 
          value: false,
          comment: ''
        }
      ],
      bedroom_questions: [
        { 
          uuid: v4(),
          title: 'Is the AC functional ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Are the fans functional ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Is the Entry Lock functional ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Does TV work ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'TV programmed correctly ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'TV Remote works ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Are all electrical outlets & plug points functional ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Are all Lightbulbs functional ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Are walls damage free ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Is the WiFi functional throughout room? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Does the closet doors open & close properly ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Does the Bedroom doors open and close correctly ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Are the diffusers working and full ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        }
      ],
      bathroom_questions: [
        { 
          uuid: v4(),
          title: 'Are Geysers working ? *', 
          bathroom_values: [
            {
              title: 'Bathroom 1',
              value: true
            },
            {
              title: 'Bathroom 2',
              value: true
            },
            {
              title: 'Bathroom 3',
              value: true
            },
            {
              title: 'Bathroom 4',
              value: true
            },
            {
              title: 'Bathroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Is the hot water working ? *', 
          bathroom_values: [
            {
              title: 'Bathroom 1',
              value: true
            },
            {
              title: 'Bathroom 2',
              value: true
            },
            {
              title: 'Bathroom 3',
              value: true
            },
            {
              title: 'Bathroom 4',
              value: true
            },
            {
              title: 'Bathroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Is the cold water working ? *', 
          bathroom_values: [
            {
              title: 'Bathroom 1',
              value: true
            },
            {
              title: 'Bathroom 2',
              value: true
            },
            {
              title: 'Bathroom 3',
              value: true
            },
            {
              title: 'Bathroom 4',
              value: true
            },
            {
              title: 'Bathroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Is the cold shower working ? *', 
          bathroom_values: [
            {
              title: 'Bathroom 1',
              value: true
            },
            {
              title: 'Bathroom 2',
              value: true
            },
            {
              title: 'Bathroom 3',
              value: true
            },
            {
              title: 'Bathroom 4',
              value: true
            },
            {
              title: 'Bathroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Is the toilet functional ? *', 
          bathroom_values: [
            {
              title: 'Bathroom 1',
              value: true
            },
            {
              title: 'Bathroom 2',
              value: true
            },
            {
              title: 'Bathroom 3',
              value: true
            },
            {
              title: 'Bathroom 4',
              value: true
            },
            {
              title: 'Bathroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Is the hot shower working ? *', 
          bathroom_values: [
            {
              title: 'Bathroom 1',
              value: true
            },
            {
              title: 'Bathroom 2',
              value: true
            },
            {
              title: 'Bathroom 3',
              value: true
            },
            {
              title: 'Bathroom 4',
              value: true
            },
            {
              title: 'Bathroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Are all lights functional ? *', 
          bathroom_values: [
            {
              title: 'Bathroom 1',
              value: true
            },
            {
              title: 'Bathroom 2',
              value: true
            },
            {
              title: 'Bathroom 3',
              value: true
            },
            {
              title: 'Bathroom 4',
              value: true
            },
            {
              title: 'Bathroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Is the Fan working ? *', 
          bathroom_values: [
            {
              title: 'Bathroom 1',
              value: true
            },
            {
              title: 'Bathroom 2',
              value: true
            },
            {
              title: 'Bathroom 3',
              value: true
            },
            {
              title: 'Bathroom 4',
              value: true
            },
            {
              title: 'Bathroom 5',
              value: true
            }
          ]
        }
      ],
      inspection_comment: '',
      inspection_by: '',

      // property search
      property : null,
      propertyAutoCompleteLoading : false,
      selected_property_id : '',
      propertiesOptions: [],
    
      // loop
      range: [1, 2, 3, 4, 5]
    }
  },
  watch: {
    uploadImagesStarted (value) {
      if (value) {
        this.$vs.loading()
      } else {
        this.$vs.loading.close()
      }
    },
    propertyAutoCompleteLoading (val) {
      if (val) {
        this.$vs.loading()
      } else {
        this.$vs.loading.close()
      }
    }
  },
  methods: {
    onRecaptchaVerified(response) {
      // console.log('Recaptcha verified:', response);
      this.captchaToken = response
      // You can do something with the response, e.g., enable the submit button.
    },
    onRecaptchaExpired() {
      // console.log('Recaptcha expired');
      this.captchaToken = null
      // You may want to handle the expiration, e.g., disable the submit button.
    },
    removeImage () {
      console.log('removeImage called with index', this.remove_index)
      if (this.remove_index > -1) {
        this.images.pop(this.remove_index)
        this.files.pop(this.remove_index)
        this.remove_index = -1
      }
      this.deleteImagePopup = false
    },
    notifyWrongFileType () {
      this.$vs.notify({
        color: 'warning',
        title: 'Wrong file Type',
        text: 'Only accepts jpg, png, and jpeg',
        time: notification_time,
        position:'top-right'
      })
    },
    imageUploaded (event) {
      if (event.target.files.length > 0) {
        const splitResults = event.target.files[0].name.split('.')
        if (!this.allowedTypes.includes(splitResults[splitResults.length - 1])) {
          this.notifyWrongFileType()
          return
        }
        const url = URL.createObjectURL(event.target.files[0])
        this.images.push(url)
        this.files.push(event.target.files[0])
      }
    },

    removeUuid (objArray) {
      const objArrayCopy = [...objArray]
      objArrayCopy.forEach((obj) => {
        delete obj.uuid
        delete obj.uuid2
      }) 
      return objArrayCopy
    },
    propertySelected (payload) {
      this.selected_property_id = payload._id
    },
    warn(msg) {
      this.$vs.notify({
        title: "",
        text: msg,
        color: "warning",
        time: notification_time,
        position: "top-right",
      });
    },
    async submitForm () {
      if (!this.captchaToken) {
        this.warn("Complete Captcha");
        return;
      }
      await this.uploadImages()
      const formObj = {
        property_id: this.selected_property_id,
        inspection_by: this.inspection_by,
        pool_questions: this.removeUuid(this.pool_questions),
        courtyard_questions: this.removeUuid(this.courtyard_questions),
        gazebo_questions: this.removeUuid(this.gazebo_questions),
        general_questions: this.removeUuid(this.general_questions),
        living_room_and_dining_room_questions: this.removeUuid(this.living_room_and_dining_room_questions),
        kitchen_questions: this.removeUuid(this.kitchen_questions),
        terrace_and_massage_room_questions: this.removeUuid(this.terrace_and_massage_room_questions),
        bedroom_questions: this.removeUuid(this.bedroom_questions),
        bathroom_questions: this.removeUuid(this.bathroom_questions),
        inspection_comment: this.inspection_comment,
        images: this.uploadedImages,
        captchaToken: this.captchaToken,
      }
      PreArrivalChecklistFormSubmission.submitForm(formObj)
        .then(response => {
          if (response.data.data.createPreArrivalChecklistForm.isSuccess) {
            this.showSuccess()
            this.captchaToken = null
            this.$refs.recaptcha.reset();
            this.resetForm()
          } else {
            showErrors(this, response.data.data.createPreArrivalChecklistForm.errors)
            this.captchaToken = null
            this.$refs.recaptcha.reset();
          }
        })
        .catch(error => {
          console.log(error)
          this.propertyAutoCompleteLoading = false
          this.captchaToken = null
            this.$refs.recaptcha.reset();
          serverError(this)
        })
    },
    resetForm () {
      
      // images
      this.uploadImagesStarted = false
      this.uploadedImages = []
      this.images = []
      this.files = []
      this.remove_index = -1
      this.deleteImagePopup = false
      // form 
      this.pool_questions = [
        { 
          uuid: v4(),
          title: 'Is the Pool pump working?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are the Pool lights working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Lion Spout working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Check if Pool cleaned ? ', 
          value: false,
          comment: ''
        }
      ]
      this.courtyard_questions = [
        { 
          uuid: v4(),
          title: 'Are all lights working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are all plug points working ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the garden cleaned ? ', 
          value: false,
          comment: ''
        }
      ]
      this.gazebo_questions = [
        { 
          uuid: v4(),
          title: 'Are all lights working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are all plug points working ? ', 
          value: false,
          comment: ''
        }
      ]
      this.general_questions = [
        { 
          uuid: v4(),
          title: 'Water pump working ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Generator working ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Genset Diesel check?', 
          value: false,
          comment: ''
        }
      ]
      this.living_room_and_dining_room_questions = [
        { 
          uuid: v4(),
          title: 'AC Working ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Fans Functional?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is Entry door lock functional?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the TV working ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the TV programmed correctly ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the TV remote working ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are all electrical outlets & plug points functional ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'All light buulbs functional ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are the walls damage free ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'WiFi functional throughout room ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are the diffusers clean and full ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the Mosquito Repellent / Goodnight functioning and available ?', 
          living_room_value: false,
          dining_room_value: false,
          comment: ''
        }
      ]
      this.kitchen_questions = [
        { 
          uuid: v4(),
          title: 'Is the entry door functional ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are all electrical outlets & plug points functional ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are all light bulbs working ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are walls damage free ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the second cylinder full ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the stove working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the Aquaguard working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the Fridge working ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the Microwave working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the tap cold working? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the Coffee machine working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the washing machine working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the dryer working ? ', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is Wifi functional ? ', 
          value: false,
          comment: ''
        }
      ]
      this.terrace_and_massage_room_questions = [
        { 
          uuid: v4(),
          title: 'Are the terrace lights working ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Is the refrigerator in bar counter working ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are the lights in the massage room working ?', 
          value: false,
          comment: ''
        },
        { 
          uuid: v4(),
          title: 'Are the fans in the massage room working ?', 
          value: false,
          comment: ''
        }
      ]
      this.bedroom_questions = [
        { 
          uuid: v4(),
          title: 'Is the AC functional ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Are the fans functional ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Is the Entry Lock functional ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Does TV work ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'TV programmed correctly ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'TV Remote works ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Are all electrical outlets & plug points functional ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Are all Lightbulbs functional ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Are walls damage free ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Is the WiFi functional throughout room? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Does the closet doors open & close properly ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Does the Bedroom doors open and close correctly ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Are the diffusers working and full ? *', 
          bedroom_values: [
            {
              title: 'Bedroom 1',
              value: true
            },
            {
              title: 'Bedroom 2',
              value: true
            },
            {
              title: 'Bedroom 3',
              value: true
            },
            {
              title: 'Bedroom 4',
              value: true
            },
            {
              title: 'Bedroom 5',
              value: true
            }
          ]
        }
      ]
      this.bathroom_questions = [
        { 
          uuid: v4(),
          title: 'Are Geysers working ? *', 
          bathroom_values: [
            {
              title: 'Bathroom 1',
              value: true
            },
            {
              title: 'Bathroom 2',
              value: true
            },
            {
              title: 'Bathroom 3',
              value: true
            },
            {
              title: 'Bathroom 4',
              value: true
            },
            {
              title: 'Bathroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Is the hot water working ? *', 
          bathroom_values: [
            {
              title: 'Bathroom 1',
              value: true
            },
            {
              title: 'Bathroom 2',
              value: true
            },
            {
              title: 'Bathroom 3',
              value: true
            },
            {
              title: 'Bathroom 4',
              value: true
            },
            {
              title: 'Bathroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Is the cold water working ? *', 
          bathroom_values: [
            {
              title: 'Bathroom 1',
              value: true
            },
            {
              title: 'Bathroom 2',
              value: true
            },
            {
              title: 'Bathroom 3',
              value: true
            },
            {
              title: 'Bathroom 4',
              value: true
            },
            {
              title: 'Bathroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Is the cold shower working ? *', 
          bathroom_values: [
            {
              title: 'Bathroom 1',
              value: true
            },
            {
              title: 'Bathroom 2',
              value: true
            },
            {
              title: 'Bathroom 3',
              value: true
            },
            {
              title: 'Bathroom 4',
              value: true
            },
            {
              title: 'Bathroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Is the toilet functional ? *', 
          bathroom_values: [
            {
              title: 'Bathroom 1',
              value: true
            },
            {
              title: 'Bathroom 2',
              value: true
            },
            {
              title: 'Bathroom 3',
              value: true
            },
            {
              title: 'Bathroom 4',
              value: true
            },
            {
              title: 'Bathroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Is the hot shower working ? *', 
          bathroom_values: [
            {
              title: 'Bathroom 1',
              value: true
            },
            {
              title: 'Bathroom 2',
              value: true
            },
            {
              title: 'Bathroom 3',
              value: true
            },
            {
              title: 'Bathroom 4',
              value: true
            },
            {
              title: 'Bathroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Are all lights functional ? *', 
          bathroom_values: [
            {
              title: 'Bathroom 1',
              value: true
            },
            {
              title: 'Bathroom 2',
              value: true
            },
            {
              title: 'Bathroom 3',
              value: true
            },
            {
              title: 'Bathroom 4',
              value: true
            },
            {
              title: 'Bathroom 5',
              value: true
            }
          ]
        },
        { 
          uuid: v4(),
          title: 'Is the Fan working ? *', 
          bathroom_values: [
            {
              title: 'Bathroom 1',
              value: true
            },
            {
              title: 'Bathroom 2',
              value: true
            },
            {
              title: 'Bathroom 3',
              value: true
            },
            {
              title: 'Bathroom 4',
              value: true
            },
            {
              title: 'Bathroom 5',
              value: true
            }
          ]
        }
      ]
      this.inspection_comment = ''
      this.inspection_by = ''
      this.property = null

      // loop
      this.range = [1, 2, 3, 4, 5]
    },
    showSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Success',
        text: 'The form has been submitted',
        time: notification_time,
        position:'top-right'
      })
    },
    async uploadImages () {
      const length = this.files.length
      for (let i = 0; i < length; i++) {
        this.uploadImagesStarted = true
        const formData = new FormData()
        formData.append('document', this.files[i])
        console.log(JSON.stringify(formData))
        const res = await documentApi.post('', formData)
        console.log(res)
        try {
          if (res.data.isSuccess) {
            this.uploadedImages.push(res.data.body.Location)
            this.$vs.notify({
              color: 'success',
              title: 'Image Uploaded',
              text: '',
              time: notification_time,
              position:'top-right'
            })
          } else {
            showErrors(this, res.data.errors)
          }
        } catch (err) {
          serverError(this)
          console.log(err)
        } finally {
          this.uploadImagesStarted = false
        }
      }
    },
    closeCalled (index) {
      console.log('index', index)
      console.log('remove index', this.remove_index)
      this.remove_index = index
      console.log(' changedremove index', this.remove_index)
      this.deleteImagePopup = true
    },
    formatSearchResults (results) {
      this.searchResults = results
      const formatted_results = []
      results.forEach(result => {
        formatted_results.push({
          id: result._id,
          _id: result._id,
          text: result.name
        })
      })
      return formatted_results
    },
    getPropertiesList () {
      this.propertyAutoCompleteLoading = true
      PropertyApi.getForAutoComplete({})
        .then(response => {
          if (response.data.data.getAllProperties.isSuccess) {
            this.propertiesOptions = this.formatSearchResults(response.data.data.getAllProperties.body)
          } else {
            showErrors(this, response.data.data.getAllProperties.errors)
          }
          this.propertyAutoCompleteLoading = false
        }).catch(error => {
          console.log(error)
          this.propertyAutoCompleteLoading = false
          serverError(this)
        })
    }
  },
  created () {
    this.getPropertiesList()
  }

}
</script>

<style>
.con-example-images{
  max-height:500px;
  overflow: auto;
}
.form{
  background-color:#FBFFFD;
}
</style>